import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdmin } from "../context/AdminContext";
import { getAccessToken, LOGIN_PATH, STUDENT_HOME } from "../api/auth";

/**
 * Wrap every /admin/* page with this. Only logged-in staff users get through.
 * (Django still enforces admin permission on each endpoint — this guard is
 * just so non-admins never see the admin screens.)
 */
export default function AdminRoute({ children }) {
  const { status, loadAdmin } = useAdmin();
  const location = useLocation();
  const hasToken = !!getAccessToken();

  useEffect(() => {
    if (hasToken && status === "idle") loadAdmin();
  }, [hasToken, status, loadAdmin]);

  if (!hasToken) {
    return <Navigate to={LOGIN_PATH} replace state={{ from: location.pathname }} />;
  }
  if (status === "idle" || status === "loading") {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
        <div className="spinner-border" role="status" aria-label="Checking access" />
      </div>
    );
  }
  if (status === "denied") {
    // Logged in but not an admin -> back to the student side.
    return <Navigate to={STUDENT_HOME} replace />;
  }
  return children;
}